import { render, staticRenderFns } from "./AyudaTrasladoSmolt.vue?vue&type=template&id=5c794ae9&scoped=true"
import script from "./AyudaTrasladoSmolt.vue?vue&type=script&lang=js"
export * from "./AyudaTrasladoSmolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c794ae9",
  null
  
)

export default component.exports